import React from 'react'
import { useRef } from 'react'
import './Contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {AiOutlineLinkedin} from 'react-icons/ai'
import {BsWhatsapp} from 'react-icons/bs';
import emailjs from 'emailjs-com';

const Contact = () => {
  

const form = useRef();

const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm('service_umjj3k4', 'template_5du0lu4', form.current, 'A27uwYb1YDuxq2wE5') 
  e.target.reset()
};





  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact_container'>
        <div className='contact_options'>
          <article className='contact_option'>
            <MdOutlineEmail className='contact_option-icon'/>
            <h4>Email</h4>
            <h5>kumarkrishn663@gmail.com</h5>
            <a href="mailto:kumarkrishn663@gmail.com" target='_blank'>Send a message</a>
          </article>

          <article className='contact_option'>
            <AiOutlineLinkedin className='contact_option-icon'/>
            <h4>LinkedIn</h4>
            <h5>iamkrishhna</h5>
            <a href="https://www.linkedin.com/in/iamkrishhna/" target='_blank'>Send a message</a>
          </article>

          
          <article className='contact_option'>
            <BsWhatsapp className='contact_option-icon'/>
            <h4>WhatsApp</h4>
            <h5>+91 6306585375</h5>
            <a href="https://api.whatsapp.com/send?phone=916306585375" target='_blank'>Send a message</a>
          </article>


        </div>
{/* <div> */}


      <form ref={form} onSubmit={sendEmail}>
        <input type="text" name='name' placeholder='Your Full Name' required/>
      <input type="email" name='email' placeholder='Your Email' required />
      <textarea name="message" placeholder='Your Message' rows="7" required></textarea>
      <input className='btn btn-primary' type="submit" value="Send Message" />

      </form>


{/* </div> */}
      </div>
    </section>
  )
}

export default Contact